import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { MediaQueryView } from 'marketplace-ui-common/layout/components/MediaQueryView';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useAppContext } from '../../context/AppContext';
import { getConnectedAppUrl, getMarketplaceDownloadsUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ManageBuildDropdowns() {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackDropdownClicked = dropdownType => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'storefront navigation dropdown clicked',
      value: dropdownType
    }));
  };
  const trackDropdownLinkClicked = dropdownLink => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'storefront navigation link clicked',
      value: dropdownLink
    }));
  };
  return /*#__PURE__*/_jsx(MediaQueryView, {
    min: "md",
    children: /*#__PURE__*/_jsxs(Flex, {
      gap: "500",
      children: [/*#__PURE__*/_jsx(ManageDropdown, {
        trackDropdownClicked: trackDropdownClicked,
        trackDropdownLinkClicked: trackDropdownLinkClicked
      }), /*#__PURE__*/_jsx(BuildDropdown, {
        trackDropdownClicked: trackDropdownClicked,
        trackDropdownLinkClicked: trackDropdownLinkClicked
      })]
    })
  });
}
function ManageDropdown({
  trackDropdownClicked,
  trackDropdownLinkClicked
}) {
  const appContext = useAppContext();
  if (appContext !== 'app') return undefined;
  return /*#__PURE__*/_jsx(Dropdown, {
    buttonUse: "unstyled",
    buttonText: /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.headers.manage"
      })
    }),
    gap: "200",
    menuWidth: 200,
    onClick: () => trackDropdownClicked('MANAGE'),
    placement: "bottom",
    children: /*#__PURE__*/_jsxs(List, {
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          href: getConnectedAppUrl(appContext),
          onClick: () => trackDropdownLinkClicked('CONNECTED_APPS'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.headers.dropdown.connectedApps"
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          href: getMarketplaceDownloadsUrl(appContext),
          onClick: () => trackDropdownLinkClicked('TEMPLATES'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.headers.dropdown.templates"
          })
        })
      })]
    })
  });
}
function BuildDropdown({
  trackDropdownClicked,
  trackDropdownLinkClicked
}) {
  return /*#__PURE__*/_jsx(Dropdown, {
    buttonUse: "unstyled",
    buttonText: /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.headers.build"
      })
    }),
    gap: "200",
    menuWidth: 200,
    onClick: () => trackDropdownClicked('BUILD'),
    placement: "bottom",
    children: /*#__PURE__*/_jsx(List, {
      children: /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          href: "https://developers.hubspot.com/",
          onClick: () => trackDropdownLinkClicked('APP'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.headers.dropdown.apps"
          })
        })
      })
    })
  });
}